import React from 'react';
import { Box, Button, Typography, Fade } from '@mui/material';
import { SystemUpdateAlt as UpdateIcon } from '@mui/icons-material';

const VersionUpdateBanner = ({ onReload }) => (
  <Fade in={true}>
    <Box
      sx={{
        backgroundColor: '#eff6ff',
        borderBottom: '1px solid #93c5fd',
        padding: '8px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: 0,
        minHeight: '40px',
        zIndex: 1300,
        position: 'relative',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <UpdateIcon sx={{ color: '#1d4ed8', fontSize: 18 }} />
        <Typography variant="body2" sx={{ color: '#1e40af', fontSize: '14px' }}>
          A new version is available.
        </Typography>
      </Box>
      <Button
        variant="text"
        size="small"
        onClick={onReload}
        sx={{
          color: '#1d4ed8',
          fontSize: '14px',
          fontWeight: 600,
          textTransform: 'none',
          minWidth: 'auto',
          padding: '4px 8px',
          '&:hover': {
            backgroundColor: 'transparent',
            color: '#1e3a8a',
          },
        }}
      >
        Reload
      </Button>
    </Box>
  </Fade>
);

export default VersionUpdateBanner;
